var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: [_vm.mobile ? "w-full justify-center flex" : null] },
    [
      _c("v-autocomplete", {
        ref: "globalSearch",
        class: [
          "soli-blue-text justify-self-center",
          _vm.round ? "round-search" : null,
          _vm.limitWidth ? "limit-width" : null,
          _vm.users ? null : "white",
          _vm.elevated ? "elevation-1" : null,
        ],
        attrs: {
          items: _vm.items,
          loading: _vm.isLoading,
          "item-text": _vm.getSearchText,
          "item-value": "id",
          "hide-no-data": _vm.hideNoData,
          "no-data-text": `No ${_vm.unit}s found`,
          "hide-details": "",
          "return-object": "",
          "search-input": _vm.search,
          "menu-props": _vm.mobile
            ? {
                left: true,
              }
            : {
                "max-width": _vm.width,
                "min-width": _vm.width,
              },
          "single-line": "",
          rounded: "",
          filled: !_vm.mobile || !_vm.users,
          solo: _vm.mobile || !_vm.users,
          dense: (!_vm.mobile || !_vm.users) && !_vm.tall,
          label: _vm.showMacros ? "+ F" : _vm.label,
          "append-icon": "search",
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.search = $event
          },
          "update:search-input": function ($event) {
            _vm.search = $event
          },
          "hook:mounted": function ($event) {
            return _vm.getWidth()
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            $event.preventDefault()
          },
          input: _vm.visit,
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (data) {
              return [
                _vm.users
                  ? _c("v-list-item-avatar", [
                      _c("img", {
                        attrs: {
                          src: data.item.profile_photo_path
                            ? `/api/image-service/40x40/${data.item.profile_photo_path}`
                            : data.item.profile_photo_url,
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-list-item-content",
                  { staticClass: "flex flex-fill items-center" },
                  [
                    _c(
                      "v-list-item-title",
                      { staticClass: "flex" },
                      [
                        _c("span", [_vm._v(_vm._s(data.item.name))]),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex gap-1 justify-end" },
                          [
                            data.item.type == "user"
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: `/profile/${data.item.id}/account`,
                                      target: "_blank",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reset()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "dark" } },
                                      [_vm._v("launch")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.users &&
                            !data.item.locations
                              .map((e) => e.id)
                              .includes(
                                _vm.$page.props.auth.user.selected_location.id
                              )
                              ? _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "error" } },
                                  [_vm._v("wrong_location")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.users && data.item.type == "lead"
                              ? _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "accent" } },
                                  [_vm._v("recent_actors")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.users
                      ? _c("v-list-item-subtitle", [
                          _vm._v(
                            _vm._s(
                              data.item.email ??
                                data.item.relationships[0]?.email ??
                                ""
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    data.item.phone
                      ? _c("v-list-item-subtitle", [
                          _vm._v(_vm._s(data.item.phone)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.unit == "article"
                      ? _c(
                          "v-list-item-subtitle",
                          { staticClass: "font-weight-bold" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  `${data.item.category.title}${
                                    data.item.program
                                      ? " > " + data.item.program.title
                                      : ""
                                  }`
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.unit == "article"
                      ? _c(
                          "v-list-item-subtitle",
                          { staticClass: "font-weight-black" },
                          [_vm._v(_vm._s(data.item.title))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }